import type { CSSProperties } from 'react';

export const CHART_TOOLTIP_STYLE: CSSProperties = {
  background: 'hsl(210, 40%, 98%)',
  border: '1px solid hsl(210, 25%, 88%)',
  borderRadius: '8px',
  color: 'hsl(210, 50%, 10%)',
  fontSize: '12px',
  padding: '8px 12px',
};

export const CHART_GRID_STROKE = '#d4dce8';

export const CHART_AXIS_TICK = { fontSize: 11, fill: 'hsl(210, 20%, 50%)' };

export const CHART_LEGEND_STYLE = { fontSize: 12, paddingTop: 0 };
